import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Collapse, ConfigProvider } from 'antd';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toggleSubMenu } from '../../../../modules/ui/store/ui-slice';
import useMenuItems, { MenuItem } from '../../hooks/use-menu-items';
import MainMenuCollapseHeader from '../main-menu-collapse-header/main-menu-collapse-header';
import styles from './main-menu-mobile.module.css';

const MainMenuMobile = (): JSX.Element => {
  const [menuItems, activeMenuItem] = useMenuItems();
  const dispatch = useDispatch();

  const expandIcon = useCallback(
    (isActive: boolean | undefined, item: MenuItem) => {
      if (!item.subMenuContent) {
        return null;
      }
      return <div onClick={() => dispatch(toggleSubMenu())}> {isActive ? <UpOutlined /> : <DownOutlined />}</div>;
    },
    [dispatch],
  );

  return (
    <>
      {menuItems.map(item => (
        <ConfigProvider
          key={item.key}
          theme={{
            token: {
              paddingSM: 8,
            },
          }}
        >
          <Collapse
            ghost
            expandIconPlacement="end"
            onChange={() => dispatch(toggleSubMenu())}
            expandIcon={({ isActive }) => expandIcon(isActive, item)}
          >
            <Collapse.Panel
              key={item.key}
              collapsible="icon"
              header={<MainMenuCollapseHeader menuItem={item} activeMenuItem={activeMenuItem} />}
            >
              <div className={styles.submenu}>{item?.subMenuContent}</div>
            </Collapse.Panel>
          </Collapse>
        </ConfigProvider>
      ))}
    </>
  );
};

export default MainMenuMobile;
